import BreathingAnalytics from "../shared/BreathingAnalytics";

export default function CopdAnalytics() {
  return <BreathingAnalytics kind="copd" backTo="/app/copd" />;
}
